import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M28.281 2.281l1.438 1.438L20.406 13H29v2H17V3h2v8.594zM3 17h12v12h-2v-8.594l-9.281 9.313-1.438-1.438L11.594 19H3v-2z" /></svg>);